<template>
    <div class="search-container">
        <input type="text" class="form-control" v-model="query" @keyup="dsearch" name="search_string" placeholder="Что вы хотите найти?">
        <div class="search-result" v-if="result.length>0">
            <ul class="list-unstyled text-left">
                <li v-for="item in result" :key="item.uid" ><a class="py-1 px-3 border border-top-0" :class="{ 'category' : item.type=='category' }" :href="item.href" v-html="item.name"></a></li>
            </ul>
        </div>
    </div>

</template>
<script>

    import {_} from 'vue-underscore';

    export default {
        name: 'SearchString',
        data() {
            return {
                query: null,
                result: []
            }
        },
        watch: {
            query () {
                if(this.query.length < 2) {
                    this.result = [];
                    return;
                }
                this.dsearch();
            }
        },
        methods: {
            search() {
              if(!this.query){
                 this.result = [];
              }
                this.$http.post('/catalog/quick-search', {'query': this.query, 'max_result_count' : 100}).then(response => {
                    this.result = response.data
                })
            },
            dsearch: _.debounce( function() {
                this.search()
            }, 500)
        }
    }
</script>
<style scoped lang="scss">
.search-container {
  position: relative;
  z-index: 100;

  .search-result {
    background: white;
    position: absolute;
    top: 38px;
    left: 5px;
    background: white;
    max-height: 400px;
    overflow: auto;

    a {
      color: grey;
      display: block;

      &:hover {
        color: #A91B39FF;
        background: #f9f9f9;
      }

      &.category {
        font-size: 120%;
      }

    }
  }
}


</style>